import { courseProgressPercent } from '@ezchops/model/lib/lesson';
import LockIcon from '@mui/icons-material/Lock';
import { Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { RoutingContext } from '../lesson/context/RoutingContext';
import { CourseProgressBar } from './CourseProgressBar';
import { InstructorInfo } from './InstructorInfo';
import { texts } from './intl';
import { Tags } from './Tags';
export function CourseCard({ course, progress, userAuthorized }) {
    const { courseUrl } = React.useContext(RoutingContext);
    return React.createElement(CourseCardStyle, { raised: false, variant: "outlined", level: course.tags.level },
        React.createElement(CardActionArea, { href: courseUrl(course) },
            React.createElement(CardContent, null,
                React.createElement(CourseProgressBar, { value: progress != null ? courseProgressPercent(progress) : 0 }),
                React.createElement(Typography, { className: "CourseName", variant: "h5", component: "h3" }, course.name),
                React.createElement(InstructorInfo, { instructor: course.instructor }),
                React.createElement(Typography, { className: "CourseDescription", variant: "body2" }, course.description),
                React.createElement(Stack, { className: "CourseInfo" },
                    React.createElement(Tags, { tags: course.tags }),
                    React.createElement(Stack, { className: "LessonCount" },
                        React.createElement(Typography, { className: "Count", variant: "h5", component: "span" }, course.lessons.length),
                        React.createElement(Typography, { className: "Label", variant: "overline2" }, texts.labels.course.lessonCount))))),
        !course.free && !userAuthorized && React.createElement(LockedOverlay, { color: "warning" },
            React.createElement(LockIcon, null)));
}
export const LockedOverlay = styled(Avatar)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    width: '50px',
    height: '50px',
    backgroundColor: theme.palette.warning.main
}));
const CourseCardStyle = styled(Card, {
    slot: 'Root',
    name: 'CourseCard',
    shouldForwardProp: (prop) => prop !== 'level'
})(({ theme, level }) => {
    const levelColor = level != null ? theme.palette.level[level] : theme.palette.augmentColor({
        color: { main: theme.palette.text.primary }
    });
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        height: '360px',
        borderRadius: '8px',
        position: 'relative',
        border: `1px solid ${levelColor.main}`,
        '& .MuiCardActionArea-root': {
            flexGrow: 1,
            flexShrink: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'stretch',
            alignItems: 'stretch',
            height: '100%',
        },
        '& .MuiCardHeader-root .MuiTypography-h5': {
            lineHeight: 1
        },
        '& .MuiCardContent-root': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'stretch',
            alignItems: 'stretch',
            flexGrow: 1,
            flexShrink: 1,
            height: '100%',
            padding: theme.spacing(3),
            gap: theme.spacing(1)
        },
        '& .CourseProgress': {
            flexGrow: 0,
            flexShrink: 0,
        },
        '& .CourseName': {
            flexGrow: 0,
            flexShrink: 0,
            lineHeight: 1,
            marginTop: theme.spacing(1)
        },
        '& .CourseDescription': {
            flexGrow: 1,
            flexShrink: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '& .CourseInfo': {
            flexGrow: 0,
            flexShrink: 0,
            flexDirection: 'row',
            alignItems: 'stretch',
            justifyContent: 'stretch',
            gap: theme.spacing(2),
            '& .LessonCount': {
                flexGrow: 0,
                flexShrink: 0,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',
                '& .Count': {
                    lineHeight: 1,
                    textAlign: 'center',
                },
                '& .Label': {
                    lineHeight: 1,
                    textAlign: 'center',
                }
            },
            '& .Tags': {
                marginTop: theme.spacing(2),
            }
        }
    };
});
//# sourceMappingURL=CourseCard.js.map